import '../styles/components/_ScreenReaderText.scss'
function ScreenReaderText ({screenReaderText,visibleText}) {
    return <span><span className='screen-reader-text'>{screenReaderText}</span><span aria-hidden>{visibleText}</span></span>
}

export default ScreenReaderText;